import { render, staticRenderFns } from "./GiftItem.vue?vue&type=template&id=2ef82f1c"
import script from "./GiftItem.vue?vue&type=script&lang=js"
export * from "./GiftItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports